import React, { useEffect } from 'react'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Tooltip from '@mui/material/Tooltip'
import WorkspacesIcon from '@mui/icons-material/Workspaces'
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks'
import {
  selectCollisionDetectionEnabled,
  setCollisionDetectionEnabled,
} from '@user/store/map'
import {
  IUserPreferenceGeneralListItemType,
  saveGeneralPreferences,
  userGeneralPreferencesList,
} from '@user/store/userPreferences/userPreferencesGeneral'
import { getPreferredCollisionDetectionEnabled } from './mapView'

export function CollisionToggle() {
  const dispatch = useAppDispatch()
  const enabled = useSelector(selectCollisionDetectionEnabled)
  const userGeneralPreferences = useSelector(userGeneralPreferencesList)
  const preferredCollisionDetectionEnabled =
    getPreferredCollisionDetectionEnabled(userGeneralPreferences)

  // Re-sync whenever the saved preference resolves or changes — not just
  // once on mount — so a late-arriving preference load still gets picked up
  // (this exact race has bitten a sibling map preference before: SH-833).
  // If no preference has ever been saved, this is undefined and the existing
  // Redux default (map/slice.ts's collisionDetectionEnabled: true) stands.
  useEffect(() => {
    if (preferredCollisionDetectionEnabled === undefined) return
    dispatch(setCollisionDetectionEnabled(preferredCollisionDetectionEnabled))
  }, [preferredCollisionDetectionEnabled, dispatch])

  const handleToggle = () => {
    const next = !enabled
    dispatch(setCollisionDetectionEnabled(next))
    dispatch(
      saveGeneralPreferences({
        type: IUserPreferenceGeneralListItemType.CollisionDetectionEnabled,
        value: next ? 'true' : 'false',
      }),
    )
  }

  return (
    <Tooltip
      title={enabled ? 'Pin Density: Standard' : 'Pin Density: High'}
      placement="left"
    >
      <Paper elevation={4}>
        <IconButton sx={{ p: 1 }} onClick={handleToggle}>
          {enabled ? (
            <WorkspacesIcon fontSize="small" sx={{ color: '#1976d2' }} />
          ) : (
            <WorkspacesOutlinedIcon fontSize="small" />
          )}
        </IconButton>
      </Paper>
    </Tooltip>
  )
}
